import { FolderX, LogOut } from 'lucide-react'
import { useNavigate } from 'react-router-dom'
import { TopBar } from '@/components/shared/top-bar'
import { Button } from '@/components/ui/button'
import { useAuthStore } from '../stores/use-auth-store'
import { supabase } from '@/lib/supabase/client'

export function NoProjectsPage() {
  const navigate = useNavigate()
  const { user, signOut } = useAuthStore()

  const handleSignOut = async () => {
    await supabase.auth.signOut()
    signOut()
    navigate('/sign-in')
  }

  const userBarProps = user
    ? {
        name: user.name ?? user.email,
        email: user.email,
        initials: (user.name ?? user.email).split(' ').map((w) => w[0]).join('').slice(0, 2).toUpperCase(),
      }
    : undefined

  return (
    <div className="flex flex-col min-h-screen bg-background">
      <TopBar showProject={false} user={userBarProps} />
      <div className="flex-1 flex items-center justify-center p-6">
        <div className="text-center max-w-sm">
          <div className="w-16 h-16 rounded-2xl bg-muted flex items-center justify-center mx-auto mb-6">
            <FolderX className="w-8 h-8 text-muted-foreground" />
          </div>
          <h1 className="text-xl font-bold text-foreground mb-2">
            هنوز در پروژه‌ای عضو نیستید
          </h1>
          <p className="text-sm text-muted-foreground mb-2">
            برای دسترسی به پروژه‌ها، از مدیر سیستم درخواست عضویت کنید.
          </p>
          {user?.email && (
            <p className="text-xs font-mono text-muted-foreground bg-muted rounded px-2 py-1 inline-block mb-6">
              {user.email}
            </p>
          )}
          <Button
            variant="outline"
            className="gap-2"
            onClick={handleSignOut}
          >
            <LogOut className="w-4 h-4" />
            خروج از سیستم
          </Button>
        </div>
      </div>
    </div>
  )
}
